export const helloMessage: string = "Welcome to our one stop shop for all your solar system data, access to our Refer-a-Friend Programme."; 
export const errors: any = {
    "Request failed with status code 403": {
      title: "Something went wrong",
      message: "This was not supposed to happen and our team has been alerted. Please try again later."
    },
    "Internal Server Error": {
      title: "Something went wrong",
      message: "This was not supposed to happen and our team has been alerted. Please try again later."
    },
    "Failed to fetch": {
      title: "Something went wrong",
      message: "This was not supposed to happen and our team has been alerted. Please try again later."
    },
    "Incorrect username or password": {
      title: "Incorrect username or password",
      message: "Please try again or select 'Forgot password' and follow the prompts."
    },
    "Wrong email": {
      title: "Account not found",
      message: "We can't find an account associated with this email address."
    },
    "WRONG_OTP_REFERENCE": {
      title: "Invalid code",
      message: "Double check the code we sent you and try again"
    },
    "Password mismatch": {
      title: "Password mismatch",
      message: "Your passwords don’t match. Please try again."
    },
    "generic": {
      title: "Something went wrong",
      message: "This was not supposed to happen and our team has been alerted. Please try again."
    },
}
export const analyticsDomain: any = {
    dashboard: 'dashboard',
    profile: 'profile',
    feedback: 'feedback',
    monitorToday: 'monitorToday',
    trends: 'trends',
    referFriends: 'referFriends',
    welcome: 'welcome',
    assistant: 'assistant',
    hotWater: 'hotWater',
    savings: 'savings'
}

export const analyticsPage: any = {
  assistant: 'assistant',
  signIn: 'signIn',
  emailVerification: 'emailVerification',
  changePassword: 'changePassword',
  verifyCode: 'verifyCode',
  dashboard: 'dashboard',
  carbonTrackCustomer: 'carbonTrackCustomer',
  emuCustomer: 'emuCustomer',
  notSupportedCustomer: 'notSupportedCustomer',
  newCustomer: 'newCustomer',
  fullscreenError: 'fullscreenError',
  monitorToday : 'monitorToday',
  profile: 'profile',
  directDebitForm: 'directDebitForm',
  directDebitFormTandC: 'directDebitFormTandC',
  customerProfile: 'customerProfile',
  systemProfile: 'systemProfile',
  feedbackOptions: 'feedbackOptions',
  feedbackWrite: 'feedbackWrite',
  helpAndSupport: 'helpAndSupport',
  referFriends: 'referFriends',
  hotWaterMain: 'hotWaterMain',
  trendsHourlyHome: 'trendsHourlyHome',
  trendsHourlySolar: 'trendsHourlySolar',
  trendsHourlyBattery: 'trendsHourlyBattery',
  trendsHourlyGrid: 'trendsHourlyGrid',
  trendsDailyHome: 'trendsDailyHome',
  trendsDailySolar: 'trendsDailySolar',
  trendsDailyBattery: 'trendsDailyBattery',
  trendsDailyGrid: 'trendsDailyGrid',
  trendsMonthlyHome: 'trendsMonthlyHome',
  trendsMonthlySolar: 'trendsMonthlySolar',
  trendsMonthlyBattery: 'trendsMonthlyBattery',
  trendsMonthlyGrid: 'trendsMonthlyGrid',
  hotWaterTroubleshooting: 'hotWaterTroubleshooting',
  hotWaterControlReminder: 'hotWaterControlReminder',
  netGridUsageBreakdown: 'netGridUsageBreakdown',
  gridRates: 'gridRates',
  sunshineReport: 'sunshineReport'
}

export const analyticsCta: any = {
    
    // Welcome
    signIn: 'signIn',
    signInError: 'signInError',
    togglePasswordShow: 'togglePasswordShow',
    forgotPassword: 'forgotPassword',
    emailValidationReceiveCode: 'emailValidationReceiveCode',
    emailValidationVerifyCode: 'emailValidationVerifyCode',
    rememberMe: 'rememberMe',
    
    // Dashboard
    tileSystemPerformance: 'tileSystemPerformance',
    tileSolarUtilization: 'tileSolarUtilization',
    tileTotalHomeUsage: 'tileTotalHomeUsage',
    tileSolarGeneration: 'tileSolarGeneration',
    tileGridImport: 'tileGridImport',
    tileGridExport: 'tileGridExport',
    tileHotWater: 'tileHotWater',
    tileReferFriend: 'tileReferFriend',
    energyFlowHome: 'energyFlowHome',
    energyFlowSolar: 'energyFlowSolar',
    energyFlowBattery: 'energyFlowBattery',
    energyFlowGrid: 'energyFlowGrid',
    energyFlowDescription: 'energyFlowDescription',
    profile: 'profile',
    tileNetGridImport: 'tileNetGridImport',
    tileNetGridTimeOfUseImport: 'tileNetGridTimeOfUseImport',
    timeOfUseIndicator: 'timeOfUseIndicator',
    hideWelcomeBanner: 'hideWelcomeBanner',
    carbonTrackLogin: 'carbonTrackLogin',
    emuCustomerContactUs: 'emuCustomerContactUs',
    newCustomerContactUs: 'newCustomerContactUs',
    systemErrorContactUs: 'systemErrorContactUs',
    
    // trends
    trendsHome: 'trendsHome',
    trendsSolar: 'trendsSolar',
    trendsBattery: 'trendsBattery',
    trendsGrid: 'trendGrid',
    trendsSelectDaily: 'trendsSelectDaily',
    trendsSelectMonthly: 'trendsSelectMonthly',
    trendsSelectYearly: 'trendsSelectYearly',
    trendsPreviousDay: 'trendsPreviousDay',
    trendsNextDay: 'trendsNextDay',
    trendsCalendarDay: 'trendsCalendarDay',
    trendsPreviousMonth: 'trendsPreviousMonth',
    trendsNextMonth: 'trendsNextMonth',
    trendsCalendarMonth: 'trendsCalendarMonth',
    trendsPreviousYear: 'trendsPreviousYear',
    trendsNextYear: 'trendsNextYear',
    trendsCalendarYear: 'trendsCalendarYear',
    toggleStackedView: 'toggleStackedView',

    // Profile
    impersonation: 'impersonation',
    customFaq: 'customerFaq',
    customerProfile: 'customerProfile',
    systemProfile: 'systemProfile',
    shareFeedback: 'shareFeedback',
    helpAndSupport: 'helpAndSupport',
    privacyPolicy: 'privacyPolicy',
    termsAndConditions: 'termsAndConditions',
    signOut: 'signOut',
    changePassword: 'changePassword',
    changePasswordError: 'changePasswordError',
    setupDirectDebitBankAccount: 'setupDirectDebitBankAccount',
    directDebitFormEntry: 'directDebitFormEntry',
    directDebitConsent: 'directDebitConsent',
    directDebitFormSubmitted: 'directDebitFormSubmitted',
    // Monitor
    monitorHomeUsageSolar: 'monitorHomeUsageSolar',
    monitorHomeUsageGrid: 'monitorHomeUsageGrid',
    monitorSolarUtilizationHouseAndBattery: 'monitorSolarUtilizationHouseAndBattery',
    monitorSolarExportedToGrid: 'monitorSolarExportedToGrid',
    
    
    // Refer a Friend
    referFriendShareCode: 'referFriendShareCode',
    referFriendCopyCode: 'referFriendCopyCode',
    
    // Contact Us
    contactUs: 'contactUs',
    termsAndCondition: 'termsAndCondition',
    
    // Feedback
    selectFeedbackFlow: 'selectFeedbackFlow',
    canContactMe: 'canContactMe',
    sendFeedback: 'sendFeedback',
    
    // Assistant
    sendMessage: 'sendMessage',
    
    // Hot Water
    enableHotWaterEnergySaving: 'enableHotWaterEnergySaving',
    pauseHotWaterEnergySaving: 'pauseHotWaterEnergySaving',
    disableHotWaterEnergySaving: 'disableHotWaterEnergySaving',
    hotWaterTroubleshooting: 'hotWaterTroubleshooting',
    hotWaterTroubleshootingQuestion: 'hotWaterTroubleshootingQuestion',
    hotWaterControlReminder: 'hotWaterControlReminder',
    hotWaterControlReminderHide: 'hotWaterControlReminderHide',
    hotWaterControlReminderLater: 'hotWaterControlReminderLater',
}

export const app: any = {
  id: 'my.solarzero.co.nz',
  version: process.env.REACT_APP_WEB_APP_VERSION || '1.0',
  build: process.env.REACT_APP_WEB_APP_BUILD || '1.0',
}

export const getPageName = (id: string, domain: string) => {
  let name = domain
  switch(id+domain) {
    case 'hometrends': 
      name = analyticsPage.trendsHourlyHome;
      break;
    case 'solartrends': 
      name = analyticsPage.trendsHourlySolar;
      break;
    case 'gridtrends': 
      name = analyticsPage.trendsHourlyGrid;
      break;
    case 'batterytrends': 
      name = analyticsPage.trendsHourlyBattery;
      break;
    default: 
      break;
  }

  return name
}
  